import { alpha, Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { WelcomeBannerProps } from './WelcomeBanner';

export default function BulletList({ pageType }: WelcomeBannerProps) {
    const { t } = useTranslation('navigation');
    const bulletPoints = t('welcomeBanner.bulletPoints', { context: pageType, returnObjects: true }) as string[];

    if (bulletPoints.length === 0) {
        return null;
    }

    return (
        <BulletListContainer>
            { bulletPoints.map((point, index) => (
                <BulletListItemContainer key={ index }>
                    <Bullet />
                    <Typography variant="caption"
                        color="primary.light">{ point }</Typography>
                </BulletListItemContainer>
            )) }
        </BulletListContainer>
    );
}

const BulletListContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(3),
    flexWrap: 'wrap'
}));

const BulletListItemContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
}));

const Bullet = styled('div')(({ theme }) => ({
    backgroundColor: alpha(theme.palette.secondary.main, 0.4),
    height: theme.spacing(2),
    width: theme.spacing(2),
    borderRadius: '100%'
}));
